











































































































































































































































































































































import useMessageTemplates from "@/composables/useMessageTemplates";
import useChannels from "@/composables/v2.1/useChannels";
import { TemplateCategory, TemplateInterface, TemplateStatus } from "@/interfaces/template.interface";
import axios from "@/libs/axios"; // @ts-ignore
import i18n from "@/libs/i18n";
import { PlatformType } from "@/types/platform.type";
import { ProviderType } from "@/types/provider.type";
import { PropOptions, ref, SetupContext } from "@vue/composition-api";
import {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCardText,
    BCol,
    BContainer,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BLink,
    BListGroup,
    BListGroupItem,
    BPagination,
    BPopover,
    BRow,
    BSpinner,
    BTab,
    BTable,
    BTabs,
    BTooltip,
} from "bootstrap-vue"; // @ts-ignore
import vSelect from "vue-select";
import { useToast } from "vue-toastification/composition";
import useTemplatesList from "./useTemplatesList";

export default {
    components: {
        BFormGroup,
        BListGroup,
        BListGroupItem,
        BFormCheckboxGroup,
        vSelect,
        BBadge,
        BAvatar,
        BContainer,
        BFormCheckbox,
        BCard,
        BRow,
        BCol,
        BFormInput,
        BButton,
        BTable,
        BDropdown,
        BDropdownItem,
        BPagination,
        BCardText,
        BTabs,
        BTab,
        BLink,
        BSpinner,
        BPopover,
        BTooltip,
    },
    setup(props: PropOptions, context: SetupContext) {
        const toast = useToast();
        const {
            read,
            refetchData,
            getManyTemplates,
            tableColumns,
            perPage,
            currentPage,
            total,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refTable,
            isLoading,
            filters,
        } = useTemplatesList();
        const isDeletingId = ref(-1);
        const { getLanguageFromShortCode } = useMessageTemplates();

        const deleteTemplate = async (template: TemplateInterface) => {
            isDeletingId.value = template.id!;

            const otherTemplatesToDelete: TemplateInterface[] = await getManyTemplates({
                s: {
                    $and: [
                        {
                            id: {
                                $ne: template.id,
                            },
                        },
                        {
                            wabaId: {
                                $eq: template.wabaId,
                            },
                        },
                        {
                            title: {
                                $eq: template.title,
                            },
                        },
                    ],
                },
            });

            const messageboxText =
                otherTemplatesToDelete.length > 0
                    ? i18n.tc(
                          "settings.whatsapp-templates.delete.multiple-languages-warning",
                          otherTemplatesToDelete.length,
                          {
                              languages: otherTemplatesToDelete
                                  .map((template) => getLanguageFromShortCode(template.language!))
                                  .join(", "),
                          }
                      )
                    : i18n.t("settings.whatsapp-templates.delete.single-deleted-template-warning");

            context.root.$bvModal
                .msgBoxConfirm(messageboxText, {
                    title: i18n.t("confirm.Are you sure?"),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.tc("settings.whatsapp-templates.delete.confirm", otherTemplatesToDelete.length + 1),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                })
                .then((result: unknown) => {
                    if (!result) {
                        isDeletingId.value = -1;
                        return;
                    }

                    axios
                        .delete(`templates/${template.id}`)
                        .then(() => {
                            toast.success(
                                i18n.tc("settings.whatsapp-templates.delete.success", otherTemplatesToDelete.length + 1)
                            );
                            refetchData();
                        })
                        .catch(() => {
                            toast.error(i18n.t("settings.whatsapp-templates.delete.error"));
                        })
                        .finally(() => (isDeletingId.value = -1));
                });
        };

        const getVariantByStatus = (status: TemplateStatus) => {
            switch (status.toLowerCase()) {
                case TemplateStatus.APPROVED:
                    return "success";
                case TemplateStatus.REJECTED:
                    return "danger";
                case TemplateStatus.PAUSED:
                    return "warning";
                default:
                    return "status-default";
            }
        };

        const getIconByStatus = (status: TemplateStatus) => {
            switch (status.toLowerCase()) {
                case TemplateStatus.APPROVED:
                    return ["fas", "check-circle"];
                case TemplateStatus.REJECTED:
                    return ["fas", "circle-xmark"];
                case TemplateStatus.PAUSED:
                    return ["fas", "circle-pause"];
                default:
                    return ["fas", "circle-exclamation"];
            }
        };

        const status = Object.values(TemplateStatus);
        const categories = Object.values(TemplateCategory);
        const { channels, fetchChannels } = useChannels();
        fetchChannels({
            params: {
                s: {
                    $or: [
                        {
                            platform: PlatformType.WHATSAPP,
                            provider: ProviderType.MESSAGEBIRD,
                        },
                        {
                            platform: PlatformType.WHATSAPP,
                            provider: ProviderType.WHATSAPP,
                        },
                        {
                            platform: PlatformType.WHATSAPP,
                            provider: ProviderType.BIRD,
                        },
                    ],
                },
                fields: "id,name",
            },
        });

        const popoverShow = ref(false);
        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        return {
            read,
            refetchData,
            tableColumns,
            perPage,
            currentPage,
            total,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refTable,
            isLoading,
            toast,
            filters,
            getVariantByStatus,
            getIconByStatus,
            status,
            categories,
            deleteTemplate,
            isDeletingId,
            channels,

            popoverShow,
            onPopoverClose,
        };
    },
    methods: {},
};
